const GROUP_INVITE_ROUTE_RE = /^\/groups\/invites\/([a-f0-9]+)$/i;

export function isGroupInviteRoute(path) {
  return GROUP_INVITE_ROUTE_RE.test(path);
}

export function getGroupInviteToken(path) {
  const match = path.match(GROUP_INVITE_ROUTE_RE);
  return match ? match[1] : null;
}
